<template>
  <v-menu offset-y :close-on-content-click="false">
    <template v-slot:activator="{ on, attrs }">
      <div class="bg-gray-200 h-full d-flex align-center px-1" v-bind="attrs" v-on="on">
        <v-btn icon>
          <v-icon>mdi-menu</v-icon>
        </v-btn>
      </div>
    </template>

    <div id="bloco-pedidos" class="bg-white font-14 w-min-300">
      <p class="row ma-0 font-12 font-weight-medium mt-2 ml-2">
        {{ pedidos.length }} Pedido{{ pedidos.length > 1 ? 's' : ''}}
      </p>

      <div class="d-flex align-center mt-1 px-2">
        <div class="d-flex align-center">
          <v-btn icon @click="checkPedidos()">
            <template v-if="pedidos_excluir.length === pedidos.length">
              <v-icon color="primary">mdi-checkbox-marked</v-icon>
            </template>
            <template v-else>
              <v-icon v-if="!pedidos_excluir.length">mdi-checkbox-blank-outline</v-icon>
              <v-icon v-else color="primary">mdi-minus-box</v-icon>
            </template>
          </v-btn>

          <span class="font-15 font-weight-medium">{{ COMPUTED_VERIFICAR_PEDIDOS ? 'Marcar todos' : 'Desmarcar todos' }}</span>
        </div>

        <v-spacer />

        <v-btn
          v-if="pedidos_excluir.length > 0"
          color="red"
          small
          dark
          class="mr-1 mt-n1"
          @click="excluirPedidosSelecionados()"
        >
          <v-icon small class="mr-1">mdi-delete</v-icon>
          excluir
        </v-btn>
      </div>

      <div
        v-for="(pedido, index) in pedidos"
        :key="pedido.idpedido"
        class="item-lista mt-n2px"
        @click="TAB_SELECIONADO = `${index}`"
      >
        <div class="d-flex align-center">
          <v-checkbox v-model="pedidos_excluir" :value="pedido" multiple hide-details class="mt-0 mr-2" @click.stop />

          <div class="ma-0 text-truncate">
            <p class="ma-0 text-truncate">
              {{ `${pedido.descricao_grupo}` }}

              <template v-if="pedido.filial !== info_pedido_geral.filial">
                - {{ `Filial ${pedido.filial}` }}
                <template v-if="pedido.descricao_filial">{{ Helpers.primeiraLetraMaiuscula(pedido.descricao_filial) }}</template>
              </template>

              <template v-if="pedido.nome_fornecedor">
                - Fornecedor {{ Helpers.primeiraLetraMaiuscula(pedido.nome_fornecedor) }}
              </template>
            </p>
          </div>
        </div>
      </div>
    </div>
  </v-menu>
</template>

<script>
import Api from '@/api/api';
import {info_pedido_geral} from "@/components/compra/ProdutosGerais/InfoPedidoGeral";

export default {
  name: "MenuMudarPedidoSelecionado",
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: [Number, String],
    pedidos: Array,
    default: () => ([])
  },
  data: () => ({
    info_pedido_geral,
    pedidos_excluir: []
  }),
  computed: {
    TAB_SELECIONADO: {
      get: function () {
        return this.modelValue;
      },
      set: function (valor) {
        return this.$emit('update:modelValue', valor);
      }
    },
    COMPUTED_VERIFICAR_PEDIDOS() {
      return this.pedidos_excluir.length < this.pedidos.length;
    }
  },
  methods: {
    checkPedidos() {
      if (this.COMPUTED_VERIFICAR_PEDIDOS) {
        this.pedidos_excluir = this.pedidos;
      } else {
        this.pedidos_excluir = [];
      }
    },
    excluirPedidosSelecionados() {
      const params = {
        array_excluir: this.pedidos_excluir
      }

      Api.post('compras/produtos/excluir-pedidos', params)
        .then(() => {
          this.$emit('excluir-pedidos-carrinho-produtos-a-comprar');
          this.pedidos_excluir = [];
        })
        .catch(this.Helpers.logout)
        .finally(() => this.loading = false);
    }
  }
}
</script>

<style scoped>
#bloco-pedidos {
  max-height: calc(100vh - 300px);
  max-width: 650px;
  overflow-y: auto;
}
.item-lista {
  padding: 12px 8px;
  border-bottom: 1px solid #e9e9e9;
}
.item-lista:hover {
  background: #f7f7f7;
  cursor: pointer;
}
</style>
